import { useEffect } from 'react'
import {
  SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT,
  SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT,
} from 'shared/constants'
import { useFeature } from 'flagged'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import BirthdayWishlistModal from './BirthdayWishlistModal'
import { CurrentUser, Responses } from '../../global'

const BIRTHDAY_WISHLIST_MODAL_LOCAL_STORAGE_KEY =
  'birthdayWishlistModalNotificationDismissed'

export const useDisplayBirthdayWishlistModal = (
  registry: Responses.Registry,
  eventLocation: string
) => {
  const [currentUser] = useCurrentUser()
  const isBirthdayWishlistModalEnabled = useFeature(
    'show_birthday_list_feature_modal'
  )

  useEffect(() => {
    if (isBirthdayWishlistModalEnabled) {
      displayBirthdayWishlistModal(registry, eventLocation, currentUser)
    }
  }, [isBirthdayWishlistModalEnabled, currentUser])
}

export const displayBirthdayWishlistModal = (
  registry: Responses.Registry,
  eventLocation: string,
  currentUser: CurrentUser | undefined
) => {
  if (!window) return
  if (!currentUser) return

  // Only show once per user
  const isDismissed = localStorage.getItem(
    BIRTHDAY_WISHLIST_MODAL_LOCAL_STORAGE_KEY
  )
  if (isDismissed) return

  // Only show for user accounts that are at least 7 days old
  const userCreatedAt = new Date(currentUser.createdAt)
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  if (userCreatedAt > sevenDaysAgo) return

  // Only show if user has registries
  if (currentUser.registries?.length < 1) return

  // Don't show if the user already has a birthday wishlist
  if (
    currentUser.registries?.some(
      (registry) => registry.registryType === 'birthday'
    )
  )
    return

  // Delay opening of modal for 5 seconds
  setTimeout(() => {
    PubSub.publish(SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT, {
      renderContent: (cm: () => void) => (
        <BirthdayWishlistModal
          closeModal={cm}
          eventLocation={eventLocation}
          registry={registry}
        />
      ),
      onModalOpen: () =>
        localStorage.setItem(BIRTHDAY_WISHLIST_MODAL_LOCAL_STORAGE_KEY, 'true'),
    })
    PubSub.publish(SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT)
  }, 5_000)
}
